import { useState, useEffect, useCallback } from 'react'
import { useSafeOptimizelyFeature } from '@chegg/optimizely-sdk'
import { initializedSelector } from '@chegg-wt/core/state/app/selectors'
import { isProSelector, hasPaperSelector } from '@chegg-wt/core/state/user/selectors'
import { setPaperUploaded } from '@chegg-wt/core/state/user/actions'
import { useSelector, useDispatch } from 'react-redux'
import { UPLOAD_WIDGET_DEMO_FEATURE } from '@chegg-wt/core/state/optimizely/constants'

export interface UseUploadWidgetDemoPageResults {
  demoTextEnabled: boolean
  uploadPaper: VoidFunction
}

const useUploadWidgetDemoPage = (): UseUploadWidgetDemoPageResults => {
  const [demoTextEnabled, setDemoTextEnabled] = useState<boolean>(false)
  const isPro = useSelector(isProSelector)
  const initialized = useSelector(initializedSelector)
  const hasPaper = useSelector(hasPaperSelector)
  const dispatch = useDispatch()
  const { isEnabled: isFeatureEnabled, clientReady } = useSafeOptimizelyFeature(
    UPLOAD_WIDGET_DEMO_FEATURE
  )

  const uploadPaper = useCallback(() => {
    dispatch(setPaperUploaded(true))
  }, [dispatch])

  useEffect(() => {
    if (!initialized) return

    const shouldAllocate = !isPro && !hasPaper

    if (shouldAllocate && clientReady) {
      setDemoTextEnabled(isFeatureEnabled)
    } else {
      setDemoTextEnabled(false)
    }
  }, [initialized, isPro, hasPaper, clientReady, isFeatureEnabled])

  return {
    demoTextEnabled,
    uploadPaper,
  }
}

export default useUploadWidgetDemoPage
